import Config from '../../../config/Config'
import { mergeMap, map, catchError, withLatestFrom } from 'rxjs/operators'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { ofType } from 'redux-observable'
import { headersSelector } from '../../auth/selectors'
import { rootCatchError } from '../../../lib/Utils'
import * as actions from '../actions'

export const resetCampaignObservable = ([action, state]) => {
  const headers = headersSelector(state)
  const { campaignId } = action.payload

  if (!headers) {
    throw new Error('Bad or Non-existent auth headers')
  }

  if (!campaignId) {
    throw new Error('payload.campaignId is required')
  }

  const settings = {
    method: 'POST',
    responseType: 'json',
    headers,
    url: `${Config.API_BASE}/v2/campaigns/${campaignId}/reset`,
  }

  return ajax(settings).pipe(
    map((payload) => {
      return {
        type: actions.RESET_CAMPAIGN_FULFILLED,
        payload: {
          response: payload.response,
        },
        meta: {
          campaignId,
        },
      }
    }),
    catchError((payload) => {
      return of({
        type: actions.RESET_CAMPAIGN_REJECTED,
        payload: {
          response: payload.response,
        },
        meta: {
          campaignId,
        },
      })
    }),
  )
}

export const resetCampaignEpic = (action$, state$) => {
  return action$.pipe(
    ofType(actions.RESET_CAMPAIGN),
    withLatestFrom(state$),
    mergeMap(resetCampaignObservable),
    rootCatchError(actions.RESET_CAMPAIGN_REJECTED),
  )
}
